import "core-js/modules/es.array.concat.js";

/* eslint-disable camelcase */
import React from 'react';
import { dateFormat, fundsTypeColorMap, fundsFromName } from 'enums';
import { typeColor } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var fundsListColumns = [{
  name: 'Номер',
  value: 'id'
}, {
  name: 'Основание',
  render: function render(_ref) {
    var from = _ref.from,
        credit = _ref.credit;
    return ___EmotionJSX("span", null, "".concat(fundsFromName[from], " ").concat(credit ? "#".concat(credit.number) : ''));
  }
}, {
  name: 'Сума',
  render: function render(_ref2) {
    var amount = _ref2.amount,
        currency = _ref2.currency,
        type = _ref2.type;
    return ___EmotionJSX("span", {
      css: typeColor(fundsTypeColorMap[type])
    }, amount, " ", currency);
  }
}, {
  name: 'Създаден на',
  value: 'created_at',
  dateTimeFormat: dateFormat
}];